import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';

export {
    init,
}

const POIs = [
    {
        name: 'chat',
        position: { x: 20, y: -14, z: 0 },
        color: 'white',
        sound: {
            name: 'chat',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'chat', url: new URL('../../sound/Chat.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
